import { cn } from "@/lib/chillnn/cn";

import { BodyWrapper } from "@/components/ui/body/body-wrapper";

import { EditGuideTooltip } from "@/components/features-new/custom-mail-setting/default/components/tooltip/edit-guide-tooltip";

type Props = {
	children: React.ReactNode;

	rightSidebar?: React.ReactNode;

	/**
	 * モバイル向けナビゲーション。laptop 未満で rightSidebar の代わりに表示される。
	 */
	mobileNavigation?: React.ReactNode;
};

/**
 *
 * @description Features の UI で定義される Island デザインの main を定義するコンテナ。
 *
 * @param {React.ReactNode} children - メインコンテンツ
 * @param {React.ReactNode | undefined} rightSidebar - 右サイドバー。現在ではカテゴリーのみで使用されているため、`FeatureIslandMainWithCategory` からのみ provide される。
 * @param {React.ReactNode | undefined} mobileNavigation - モバイル向けナビゲーション。laptop 未満の画面サイズで表示される。
 *
 *
 */
export const FeatureIslandMain = ({ children, rightSidebar, mobileNavigation }: Props) => {
	return (
		<div className="relative max-w-full scroll-pt-10">
			{mobileNavigation && <div className="laptop:hidden">{mobileNavigation}</div>}
			<div className="p-4 pb-20 lg:p-12 laptop:pb-4">
				<div className="flex gap-x-12">
					<div className="w-full overflow-auto">
						<form>{children}</form>
					</div>

					{rightSidebar && <div className="hidden laptop:block">{rightSidebar}</div>}
				</div>
			</div>
		</div>
	);
};

/**
 *
 * @description Features の UI で定義される Island デザインの main を定義するコンテナ。
 *
 * @param {React.ReactNode} children - メインコンテンツ
 *
 */
export const FeatureIslandMainWithBackGround = ({
	children,
	islandTitle,
	tooltipTitle,
}: Props & { islandTitle?: string; tooltipTitle?: string }) => {
	return (
		<div
			className={cn(
				"max-w-screen-screen relative mx-auto p-4 pb-20 laptop:pb-4 desktop:px-12 desktop:pb-5 desktop:pt-12",
			)}
		>
			<div className="flex w-full flex-col gap-y-3">
				<div className="flex items-center gap-x-2">
					{!!islandTitle && <h4 className="text-lg font-semibold">{islandTitle}</h4>}
					{!!tooltipTitle && <EditGuideTooltip guide={`${tooltipTitle}`} />}
				</div>

				<div className="w-full">
					<BodyWrapper>
						<form className="flex w-full flex-col gap-y-12 divide-y divide-zinc-100 [&>*:not(:first-child)]:pt-6">
							{children}
						</form>
					</BodyWrapper>
				</div>
			</div>
		</div>
	);
};
